import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { customerAddressCreate } from "../../../services/CustomerInfo/EditCustomer";

const EditCustomerAddressModal = ({
  setEditCustomerAddressModalVisible,
  editCustomerAddressModalVisible,
  editAddressFieldName,
  editAddressFieldCount,
  addressLineEditValue1,
  addressLineEditValue2,
  addressCityEditValue,
  addressStateEditValue,
  addressLandmarkEditValue,
  addressPinEditValue,
  addressEditIcon,
  addressItems,
  selectedAddressItem,
  editCustomerData,
  storeCustomerId,
  sendDataToEditCustomer,
  //   handleEditData, // Function to handle edit in EditCustomer
}) => {
  const [editAddressLineValue1, setEditAddressLineValue1] = useState(
    addressLineEditValue1
  );
  const [editAddressLineValue2, setEditAddressLineValue2] = useState(
    addressLineEditValue2
  );
  const [editAddressCityValue, setEditAddressCityValue] =
    useState(addressCityEditValue);
  const [editAddressStateValue, setEditAddressStateValue] = useState(
    addressStateEditValue
  );
  const [editAddressLandmarkValue, setEditAddressLandmarkValue] = useState(
    addressLandmarkEditValue
  );
  const [editAddressPinValue, setEditAddressPinValue] =
    useState(addressPinEditValue);

  const [data, setData] = useState();

  const [focusedField, setFocusedField] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleAddressLineOneEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressLineValue1(copyText);
  };
  const handleAddressLineTwoEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressLineValue2(copyText);
  };
  const handleAddressCityEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressCityValue(copyText);
  };
  const handleAddressStateEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressStateValue(copyText);
  };
  const handleAddressLandmarkEditChange = (text) => {
    const copyText = text.replace(/[^A-Za-z0-9\-, ]/g, "");
    setEditAddressLandmarkValue(copyText);
  };
  const handleAddressPinEditChange = (text) => {
    setEditAddressPinValue(text);
  };

  const storeId = editCustomerData?.storeId;
  const handleEditData = async () => {
    // Create a new edited field object
    const editedField = {
      editAddressFieldName: editAddressFieldName, // Store the field name
      addressLineEditValue1: editAddressLineValue1, // Store the edited field value
      fieldAddressLineTwoValue: editAddressLineValue2, // Store the edited field value
      fieldAddressCityValue: editAddressCityValue, // Store the edited field value
      fieldAddressStateValue: editAddressStateValue, // Store the edited field value
      fieldAddressLandmarkValue: editAddressLandmarkValue, // Store the edited field value
      fieldAddressPinValue: editAddressPinValue, // Store the edited field value
    };

    // Update the specific field in addressItems
    let updatedData = { ...selectedAddressItem };
    // const Id = updatedData.id;
    if (editAddressFieldName === "Address " + updatedData.id) {
      updatedData.addressLine1 = editAddressLineValue1;
      updatedData.addressLine2 = editAddressLineValue2;
      updatedData.city = editAddressCityValue;
      updatedData.state = editAddressStateValue;
      updatedData.landmark = editAddressLandmarkValue;
      updatedData.pin = editAddressPinValue;
    }
    // Add more conditions for other fields
    try {
      const response = await customerAddressCreate(
        storeCustomerId,
        storeId,
        updatedData
      );
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;
        // Step 2: Add the new edited field to the array of objects
        setData(editedField);
        // Close the modal
        setEditCustomerAddressModalVisible(false);
        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // When the editAddressFieldName or fieldNameValue changes, update the editValue
    if (
      editAddressFieldName !== null &&
      addressLineEditValue1 !== null &&
      addressLineEditValue2 !== null &&
      addressCityEditValue !== null &&
      addressStateEditValue !== null &&
      addressLandmarkEditValue !== null &&
      addressPinEditValue !== null
    ) {
      setEditAddressLineValue1(addressLineEditValue1);
      setEditAddressLineValue2(addressLineEditValue2);
      setEditAddressCityValue(addressCityEditValue);
      setEditAddressStateValue(addressStateEditValue);
      setEditAddressLandmarkValue(addressLandmarkEditValue);
      setEditAddressPinValue(addressPinEditValue);
    }
  }, [
    editAddressFieldName,
    addressLineEditValue1,
    addressLineEditValue2,
    addressCityEditValue,
    addressStateEditValue,
    addressLandmarkEditValue,
    addressPinEditValue,
  ]);

  const handleModalClose = () => {
    setEditCustomerAddressModalVisible(false);
    // setEditValue
    // setEditLastNameValue
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerAddressModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerAddressModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-map-marker"
                style={{ fontSize: "30px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Edit Address
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={editAddressLineValue1}
                onChange={(e) => handleAddressLineOneEditChange(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Address Line 1"
                className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
              ></InputText>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={editAddressLineValue2}
                onChange={(e) => handleAddressLineTwoEditChange(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Address Line 2"
                className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
              ></InputText>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={editAddressCityValue}
                onChange={(e) => handleAddressCityEditChange(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="City"
                className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
              ></InputText>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={editAddressStateValue}
                onChange={(e) => handleAddressStateEditChange(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="State"
                className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
              ></InputText>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={editAddressLandmarkValue}
                onChange={(e) =>
                  handleAddressLandmarkEditChange(e.target.value)
                }
                id="firstName"
                label="firstName"
                placeholder="Landmark"
                className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
              ></InputText>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={editAddressPinValue}
                onChange={(e) => handleAddressPinEditChange(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Pin Code"
                keyboardType="numeric"
                maxLength={6} // Restrict input to 10 characters
                className="w-full  bg-white-alpha-20 border-round-lg p-2 text-lg "
              ></InputText>
            </div>

            <Button
              onClick={handleEditData}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default EditCustomerAddressModal;
